import { Language } from '../../../types/user/User'
import { translateRecord } from '../../../utils/helpers'
import { Formula } from '../types/Formula'

export const formulasSelector = (formulas: Formula[], language: Language) => {
  return formulas.filter(f => f.isVariable === false).map(formula => translateRecord(formula, language)) as Formula[]
}

export const driverFormulasSelector = (formulas: Formula[], language: Language) => {
  return formulas
    .filter(f => f.isVariable === true)
    .sort((a, b) => a.order - b.order)
    .map(formula => translateRecord(formula, language)) as Formula[]
}
export const refArgumentOptionsSelector = (formulas: Formula[], language: Language) => {
  return formulasSelector(formulas, language)
    .filter(formula => formula.code)
    .filter(f => f.isVariable === false)
    .map(formula => ({
      name: `${formula.code} - ${formula.name}`,
      value: `'${formula.code}'`
    }))
}
export const varArgumentOptionsSelector = (formulas: Formula[], language: Language) => {
  return driverFormulasSelector(formulas, language)
    .filter(formula => formula.code)
    .filter(f => f.isVariable === true)
    .map(formula => ({
      name: `${formula.code} - ${formula.name}`,
      value: `'${formula.code}'`
    }))
}
